import { hsl } from 'polished';
export default {
    /** Hex: #FFFFFF */
    white: '#FFFFFF',
    /** Hex: #000000 */
    black: '#000000',
    /** Hex: #F54C00 (About us) */
    orange: '#F54C00',
    /** Hex: #0C6493 (Choose geography | Research) */
    blue: '#0C6493',
    /** Hex: #8E0075 (Schools) */
    purple: '#8E0075',
    /** Hex: #E00029 (Professionals) */
    red: '#E00029',
    green: {
        /** Hex: #57830A (In the field) */
        default: '#57830A',
        /** Hex: #344F06 (Collections) */
        dark: '#344F06',
    },
    /** Hex: #1A847D (Events) */
    teal: '#1A847D',
    grey: {
        /** Hex: #212121 */
        grey13: hsl(0, 0, 0.13),
        /** Hex: #585858 */
        grey20: hsl(0, 0, 0.2),
        /** Hex: #585858 */
        grey35: hsl(0, 0, 0.35),
        /** Hex: #686868 */
        grey41: hsl(0, 0, 0.41),
        /** Hex: #707070 */
        grey44: hsl(0, 0, 0.44),
        /** Hex: #999999 */
        grey60: hsl(0, 0, 0.6),
        /** Hex: #CCCCCC */
        grey80: hsl(0, 0, 0.8),
        /** Hex: #E5E5E5 */
        grey90: hsl(0, 0, 0.9),
        /** Hex: #E7E7E7 */
        grey91: hsl(0, 0, 0.91),
        /** Hex: #F7F7F7 */
        grey97: hsl(0, 0, 0.97),
    },
};
/**
 * - Orange (CSS: `${brand.orange}`) (HEX: #F54C00)
 * - Blue (CSS: `${brand.blue}`) (HEX: #0C6493)
 * - Purple (CSS: `${brand.purple}`) (HEX: #8E0075)
 * - Red (CSS: `${brand.red}`) (HEX: #E00029)
 * - Green (CSS: `${brand.green.default}`) (HEX: #57830A)
 * - DarkGreen (CSS: `${brand.green.dark}`) (HEX: #344F06)
 * - Teal (CSS: `${brand.teal}`) (HEX: #1A847D)
 * - White (CSS: `${brand.white}`) (HEX: #FFFFFF)
 */
export var ThemeOption;
(function (ThemeOption) {
    ThemeOption["Orange"] = "orange";
    ThemeOption["Blue"] = "blue";
    ThemeOption["Purple"] = "purple";
    ThemeOption["Red"] = "red";
    ThemeOption["Green"] = "green";
    ThemeOption["DarkGreen"] = "dark-green";
    ThemeOption["Teal"] = "teal";
    ThemeOption["White"] = "white";
})(ThemeOption || (ThemeOption = {}));
